import { useState, useCallback } from 'react';
import { supabase } from '../supabaseClient';
import { getHojeBR } from '../utils/dataBR';

export function useDesafios(userId) {
  const [desafioAtivo, setDesafioAtivo] = useState(null);
  const [desafiosConcluidos, setDesafiosConcluidos] = useState([]);
  const [loadingDesafio, setLoadingDesafio] = useState(false);

  const fetchDesafios = useCallback(async () => {
    if (!userId) return;
    setLoadingDesafio(true);
    const { data } = await supabase
      .from('user_desafios')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    const todos = data || [];
    setDesafioAtivo(todos.find(d => d.status === 'ativo') || null);
    setDesafiosConcluidos(todos.filter(d => d.status === 'concluido'));
    setLoadingDesafio(false);
  }, [userId]);

  const aceitarDesafio = useCallback(async (desafioData, parametroAntes) => {
    if (!userId) return { error: 'Sem usuário' };
    const { error } = await supabase.from('user_desafios').insert({
      user_id: userId,
      desafio_id: desafioData.id,
      desafio_nome: desafioData.nome,
      duracao: desafioData.duracao,
      frase_inspiradora: desafioData.frase_inspiradora || null,
      titulo_reflexao: desafioData.titulo_reflexao || null,
      prompts: desafioData.prompts || {},
      data_inicio: getHojeBR(),
      status: 'ativo',
      parametro_label: desafioData.parametro_label || null,
      parametro_pergunta_antes: desafioData.parametro_pergunta_antes || null,
      parametro_pergunta_depois: desafioData.parametro_pergunta_depois || null,
      parametro_opcoes: desafioData.parametro_opcoes || null,
      parametro_antes: parametroAntes || null,
    });
    if (!error) await fetchDesafios();
    return { error };
  }, [userId, fetchDesafios]);

  const concluirDesafio = useCallback(async (parametroDepois) => {
    if (!userId || !desafioAtivo) return { error: 'Sem desafio ativo' };
    const { error } = await supabase
      .from('user_desafios')
      .update({
        status: 'concluido',
        data_conclusao: new Date().toISOString(),
        parametro_depois: parametroDepois || null,
      })
      .eq('id', desafioAtivo.id);
    if (!error) await fetchDesafios();
    return { error };
  }, [userId, desafioAtivo, fetchDesafios]);

  return {
    desafioAtivo,
    desafiosConcluidos,
    loadingDesafio,
    fetchDesafios,
    aceitarDesafio,
    concluirDesafio,
  };
}
